import { render, staticRenderFns } from "./RegisterDialogFooter.vue?vue&type=template&id=ed1eb982&scoped=true&"
import script from "./RegisterDialogFooter.vue?vue&type=script&lang=js&"
export * from "./RegisterDialogFooter.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDialogFooter.vue?vue&type=style&index=0&id=ed1eb982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1eb982",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed1eb982')) {
      api.createRecord('ed1eb982', component.options)
    } else {
      api.reload('ed1eb982', component.options)
    }
    module.hot.accept("./RegisterDialogFooter.vue?vue&type=template&id=ed1eb982&scoped=true&", function () {
      api.rerender('ed1eb982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/dialog/RegisterDialogFooter.vue"
export default component.exports